import { render, staticRenderFns } from "./ExamPopup.vue?vue&type=template&id=6b732dd0&scoped=true&"
import script from "./ExamPopup.vue?vue&type=script&lang=js&"
export * from "./ExamPopup.vue?vue&type=script&lang=js&"
import style0 from "./ExamPopup.vue?vue&type=style&index=0&id=6b732dd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b732dd0",
  null
  
)

export default component.exports